import { IEntityDto } from "@/Core/Interfaces/IEntities";
import { z } from "zod";

// zod schema
export const utilFormSchema = z
    .object({
        id: z.string().optional(),
        name: z.string().trim().min(1, { message: "Name is required" }),
        description: z.string().optional(),
    })
    .required();

// zod infer
export type UtilFormDto = z.infer<typeof utilFormSchema>;

export type UtilResponseDto = z.infer<typeof utilFormSchema> & IEntityDto;

export interface ReferToResponseDto {
    id: string;
    name: string;
    meta?: any;
}
